<template>
  <div class="distion">
    <drag-modal :visible="visible" @cancel="reset" :title="title + '拍卖记录'" width="660px">
      <a-form-model ref="newforms" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-model-item label="估值" prop="value" :rules="{ required: false, message: '请填写估值', trigger: 'blur' }">
          <a-input type='number' v-model="form.value" placeholder="请填写估值" :disabled="edit == 0" />
        </a-form-model-item>
        <a-form-model-item label="拍卖阶段" prop="auction_step"
          :rules="{ required: true, message: '请选择拍卖阶段', trigger: 'change' }">
          <a-select placeholder="请选择拍卖阶段" v-model="form.auction_step" :disabled="edit == 0">
            <a-select-option :value="key * 1" v-for="(i, key) in Keys.stage" :key="key">
              {{ i }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="拍卖状态" prop="auction_status"
          :rules="{ required: true, message: '请选择拍卖状态', trigger: 'change' }">
          <a-select placeholder="请选择拍卖状态" v-model="form.auction_status" :disabled="edit == 0">
            <a-select-option :value="key * 1" v-for="(i, key) in Keys.status" :key="key">
              {{ i }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="拍卖开始时间" prop="auction_start_time"
          :rules="{ required: true, message: '请选择拍卖时间', trigger: 'change' }">
          <a-date-picker v-model="form.auction_start_time" placeholder="请选择" style="width: 100%;" show-time type="date"
            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled="edit == 0" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 24 }" style="margin-top: 20px">
          <Upload breadth="250px" @isDisabled="parentHandle" :fList="form.files" @upFileAfter="lisUpload"
            :edit="edit == 0" :Wid="'128px'" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 18, offset: 7 }" v-if="edit != 0">
          <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button :disabled="disabledShow" type="primary" style="margin-right: 20px; width: 148px">保存</a-button>
          </a-popconfirm>
          <a-button style="background: #b2c9e1; color: #fff; width: 148px" @click="reset">关闭</a-button>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
  </div>
</template>
<script>
import Keys from './keys'
import Upload from '@/components/uploads'
import { debtorAll } from '@/server/api'
import { auction } from '@/server/debtor'
export default {
  props: {
    info: Object
  },
  data() {
    return {
      Keys,
      rules: {},
      edit: 0,  //0查看 1新增 2编辑
      form: {
        value: null,
        item_type: null,
        auction_status: 1,
        files: [],
        status: false
      },
      useList: [],
      visible: false,
      disabledShow: false,
      file: []
    }
  },
  computed: {
    title() {
      return { 0: '查看', 1: '新增', 2: '编辑' }[this.edit]
    }
  },
  components: { Upload },
  watch: {
    info: {
      handler(newVal) {
        if (newVal.id) {
          const k = ['item_type', 'title', 'belong_debtor_id', 'car_license_number', 'value', 'auction_step', 'auction_status', 'auction_start_time', 'files', 'status', 'index']
          let nwform = {}
          k.map((ele, key) => {
            nwform[ele] = newVal[ele]
          })

          // nwform.value = nwform.value ? nwform.value / 100 : null
          nwform.value = nwform.value
          nwform.id = newVal.id
          this.form = nwform
          newVal.files.map((ele) => {
            ele.title = ele.origin_name
            ele.upload_id = Number(ele.id)
          })
          this.form.files = newVal.files
        } else {
          this.form = newVal
        }
      }
    },
    deep: true,
    immediate: true,
  },
  created() {
    debtorAll({ id: this.$route.params.id }).then(e => {
      this.useList = e.list
    })
  },
  methods: {
    lisUpload(fileList, list) {
      if (list) {
        const processedList = list.map((ele) => {
          if (!ele || typeof ele !== 'object') {
            return ele;
          }
          return {
            ...ele,
            origin_name: ele.title,
            id: ele.upload_id
          };
        });
        this.form.files = processedList;
      }
    },
    parentHandle(data) {
      this.disabledShow = data
    },
    confirm() {
      let form = JSON.parse(JSON.stringify(this.form))
      form.cause_id = this.$store.state.cause.id
      if (form.item_type != 1) delete form.car_license_number
      if (form.value) {
        form.value = form.value
      }
      this.$refs.newforms.validate((valid) => {
        if (valid) {
          if (form.status) {
            //修改
            this.$emit('update-auction', form, 'edit');
            this.$message.success({ content: '修改成功', key: 'updatable' })
            this.reset()
          } else {
            this.$message.success({ content: '新增成功', key: 'updatable' })
            this.$emit('update-auction', form, 'add');
            this.reset()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    reset() {
      this.$refs.newforms.resetFields()
      this.visible = false;
    }
  }
}
</script>